
const Data = [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: "2020 - present",
      title: "Academic Degree",
      desc: "The rigorous curriculum enhanced my skills and laid the foundation for a successful journey in the tech field.",
    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: "2014 - 2018",
      title: "Bachelor's Degree",
      desc: "I ended up honing my skills and knowledge to navigate the challenges of web development and cybersecurity.",
    },
    {
      id: 3,
      category: "education",
      icon: "icon-graduation",
      year: "2010 - 2014",
      title: "Honours Degree",
      desc: "reinforcing his commitment to excellence in creating innovative digital solutions, earning the Honors degree.",
    },
    {
      id: 4,
      category: "experience",
      icon: "icon-briefcase",
      year: "2024 - present",
      title: "Content-Creation",
      desc: "pioneered the development of dynamic content, harnessing the power of video courses to educate and inspire global audiences.",
    },
    {
      id: 5,
      category: "experience",
      icon: "icon-briefcase",
      year: "2020 - present",
      title: "Full-Stack Development",
      desc: "Led transformative web development projects, sculpting seamless digital experiences that resonate with users worldwide.",
    },
    {
      id: 6,
      category: "experience",
      icon: "icon-briefcase",
      year: "2018 - present",
      title: "Cyber-Security Expert",
      desc: "Engineered robust cybersecurity frameworks, pioneering proactive measures to safeguard digital assets and mitigate evolving threats in the digital realm.",
    },
];

export default Data;